import { NUMBER_REGEX } from '@monoimin/constants';

const findNumber = (string: string) => {
  const matches = string.match(NUMBER_REGEX);

  if (matches) {
    return Number(matches[1]);
  }

  return 0;
};

export const sortItemsByNumberTagInName = <T extends { name: string }>(
  items: Array<T>
) => {
  return items.sort((a, b) => {
    const aNumber = findNumber(a.name);

    const bNumber = findNumber(b.name);

    if (aNumber > bNumber) {
      return 1;
    }

    if (aNumber < bNumber) {
      return -1;
    }

    return 0;
  });
};

export default sortItemsByNumberTagInName;
